import { render, staticRenderFns } from "./canvasImage.vue?vue&type=template&id=616b7380&scoped=true&"
import script from "./canvasImage.vue?vue&type=script&lang=js&"
export * from "./canvasImage.vue?vue&type=script&lang=js&"
import style0 from "./canvasImage.vue?vue&type=style&index=0&id=616b7380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616b7380",
  null
  
)

export default component.exports